export function getFilteredIDiaIDs(options) {
    const { groupedDiaIDs, hoses } = options;
    const carbonDiaIDs = groupedDiaIDs
        .filter((group) => group.atomLabel === 'C')
        .sort((a, b) => {
        if (a.atomLabel === b.atomLabel) {
            return b.counter - a.counter;
        }
        return a.atomLabel < b.atomLabel ? 1 : -1;
    });
    for (const diaId of carbonDiaIDs) {
        diaId.hose = hoses[diaId.atoms[0]];
    }
    return carbonDiaIDs;
}
//# sourceMappingURL=getFilteredIDiaIDs.js.map